/**
 * Strip Latin diacritics (macron, acute, etc.) so "Bādhak" matches "Badhak" / letter B.
 * Only removes U+0300–U+036F (Latin Combining Diacritical Marks); Devanagari and
 * Gujarati vowel signs are intentionally preserved so Hindi/Gujarati searches work correctly.
 */
export function stripDiacritics(text: string): string {
  return text
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .normalize("NFC");
}

/** Lowercase + trim + strip diacritics — for sort, search, and equality. */
export function normalizeForCompare(text: string): string {
  return stripDiacritics(text.trim().toLowerCase());
}

/** First A–Z letter of a word after stripping diacritics (for browse index / badges). */
export function wordFirstLetter(word: string): string {
  const base = stripDiacritics(word.trim());
  if (!base) {
    return "";
  }
  return base.charAt(0).toUpperCase();
}

export function textIncludesNormalized(
  haystack: string | null | undefined,
  normalizedNeedle: string
): boolean {
  if (!normalizedNeedle) {
    return true;
  }
  return normalizeForCompare(haystack ?? "").includes(normalizedNeedle);
}
